import {
    UserOutlined,
    EditOutlined,
    HomeOutlined,
    UserAddOutlined,
    BankOutlined,
    TeamOutlined,
    DiffOutlined,
    FileTextOutlined,
    CreditCardOutlined,
    SettingOutlined,
    UsergroupAddOutlined,
    FileAddOutlined,
    ToolOutlined,
    FileOutlined,
    DollarCircleOutlined,
    TrademarkCircleOutlined
} from '@ant-design/icons';
const Menu = [
    {
        title: "首页",
        key: "/home",
        icon: <HomeOutlined/>
    }, {
        title: "账号管理",
        key: "/account",
        icon: <UserOutlined/>,
        children: [
            {
                title: "查询修改账号",
                key: "/account/list",
                icon: <EditOutlined/>
            }, {
                title: "添加账号",
                key: "/account/add",
                icon: <UserAddOutlined/>}
            // }, {
            //     title: "批量添加账号",
            //     key: "/account/batch-add",
            //     icon: <UserAddOutlined/>
            // }
        ]
    }, {
        title: "公司管理",
        key: "/company",
        icon: <BankOutlined/>,
        children:[
            {
                title: "公司列表",
                key: "/company/list",
                icon: <EditOutlined/>
            },
            {
                title: "新增公司",
                key: "/company/add",
                icon: <FileAddOutlined />
            },
            {
                title: "公司权限管理",
                key: "/company/rights",
                icon: <TrademarkCircleOutlined />
            }
        
        
        ]
        
    },
    {
        title: "群组管理",
        key: "/group",
        icon: <TeamOutlined/>,
        children:[
            {
                title: "查询修改群组",
                key: "/group/list",
                icon: <EditOutlined/>
            },
            {
                title: "新增群组",
                key: "/group/add",
                icon: <UsergroupAddOutlined />
            },     
        ]
    },
    {
        title: "充值卡",
        key: "/card",
        icon: <CreditCardOutlined/>,
        children:[
            {
                title: "生成充值卡",
                key: "/card/create",
                icon: <DollarCircleOutlined />
            },

        ]
    },
    {
        title: "系统管理",
        key: "/system",
        icon: <SettingOutlined/>,
        children:[
            {
                title: "系统设置",
                key: "/system/settings",
                icon:<ToolOutlined />
            },
        ]
    },
    {
        title: "操作日志",
        key: "/logs",
        icon: <FileOutlined />,
        children:[
            {
                title: "用户数充值卡日志",
                key: "/logs/card",
                icon:<DiffOutlined />
            },{
                title: "用户修改日志",
                key: "/logs/account",
                icon:<FileTextOutlined />
            }
        ]
    }
]

export default Menu